export default {
  data() {
    return {
      columns: [
        {
          title: '序号',
          width: 70,
          dataIndex: 'order',
          fixed: 'left',
          customRender: (text, record, index) =>
            (this.pageData.current - 1) * this.pageData.pageSize + (index + 1),
        },
        {
          title: '担保类型',
          dataIndex: 'typeStr',
          width: 120,
        },
        {
          title: '保证书类型',
          dataIndex: 'bookTypeStr',
          width: 120,
        },
        {
          title: '担保个人身份',
          dataIndex: 'identityStr',
          width: 120,
        },
        {
          title: '上市公司担保公告',
          dataIndex: 'assureNoticeStr',
          width: 150,
        },
        {
          title: '书面担保金额',
          dataIndex: 'writtenAmount',
          scopedSlots: { customRender: 'writtenAmount' },
          width: 120,
        },
        {
          title: '文件编号',
          dataIndex: 'code',
          width: 120,
        },
        {
          title: '文件名',
          dataIndex: 'fileName',
          width: 120,
        },
        {
          title: '担保方名称',
          dataIndex: 'assuranceName',
          width: 120,
        },
        {
          title: '上市公司',
          dataIndex: 'isListedStr',
          width: 120,
        },
        {
          title: '生效日期',
          dataIndex: 'efficientDate',
          width: 120,
        },
        {
          title: '到期日期',
          dataIndex: 'expireDate',
          width: 120,
        },
        {
          title: '货币单位',
          dataIndex: 'currencyUnit',
          scopedSlots: { customRender: 'currencyUnit' },
          width: 120,
        },
        {
          title: '有效担保金额',
          dataIndex: 'validAmount',
          scopedSlots: { customRender: 'validAmount' },
          width: 120,
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 120,
        },
        {
          title: '编辑日期',
          dataIndex: 'updateTime',
          width: 120,
        },
        {
          title: '上传人',
          dataIndex: 'operator',
          width: 120,
        },
        {
          title: '操作',
          fixed: 'right',
          width: 220,
          dataIndex: 'action',
          slotName: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      TYPE_1: 1,
      TYPE_2: 2,
      TYPE_3: 3,
      TYPE_4: 4,
      TYPE_5: 5,
      TYPE_6: 6,
      TYPE_NAME_OBJ: {
        3: '担保-房产抵押',
        4: '担保-银行保函',
        5: '担保-股权质押',
        6: '担保-库存质押',
      },
    }
  },
}
